import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="min-h-[60vh] flex flex-col items-center justify-center text-center px-6">
      <p className="overline mb-4">404</p>
      <h1 className="font-display text-5xl tracking-tighter font-light mb-4">Page not found.</h1>
      <Link to="/" className="text-sm underline">Return home</Link>
    </div>
  );
}
